module.exports = __webpack_public_path__ + "static/media/banner-slide.f437f2e6.png";